import { render } from "./AboutUs.vue?vue&type=template&id=89086364&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=89086364&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-89086364"

export default script